import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import * as filters from './filters'
import VueApexCharts from 'vue-apexcharts'
// import longClickDirective from './directives/longclick'

/* Vue.use(VueApexCharts) */

Vue.config.productionTip = false

/* const longClickInstance = longClickDirective({ delay: 400, interval: 0 })
Vue.directive('longclick', longClickInstance) */

Vue.component('apexchart', VueApexCharts)

for (const key in filters) {
  Vue.filter(key, filters[key])
}

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// router.replace('/login')